import { httpV2 } from "@/api";

const Qs = require("qs");

/**
 * Requisição de dados das tendências.
 * @param {object} parameters Objeto de parâmetros passados por query e path na requisição.
 * @returns Dados de tendência.
 */
const GetTrendCharts = function(parameters)
{
	const params = {};
	params.trendSignalSettingIds = parameters.trendSignalsIds;
	params.startDateTime = parameters.startDateTime;
	params.endDateTime = parameters.endDateTime;

	return httpV2.get("/WindReport/VDITrendCharts",
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Requisição do piores casos de IDV.
 * @param {object} parameters Objeto de parâmetros passados por query e path na requisição.
 * @returns Sinal com pior IDV.
 */
const GetWorstSignals = function(parameters)
{
	const params = {};
	params.startDateTime = parameters.startDateTime;
	params.endDateTime = parameters.endDateTime;

	return httpV2.get(`/WindReport/${parameters.monitoringElementId}/WorstCasesVDI`,
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

export default
{
	GetTrendCharts,
	GetWorstSignals,
};